import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Input from 'b2b-ui-components-lib/lib/components/input';
import PartySelector from 'b2b-ui-components-lib/lib/components/partySelector';
import useProducts from 'b2b-ui-components-lib/lib/hooks/useProducts';
import usePartyAccounts from 'b2b-ui-components-lib/lib/hooks/usePartyAccounts';
import { findParamFromUrl, getFromSessionStorage, setInSessionStorage } from 'common/utils/app.utils';
import { MODULE_ID, PROFILE_DATA, SELECTED_PARTY_ACCOUNT, SELECTED_PARTY_DATA } from 'home/common/constants/constants';
import { PARTY_AGGREGATION_LEVEL } from 'b2b-ui-components-lib/lib/constants/common';
import { LOB } from 'common/constants/app.constants';
import './index.scss';
import { getCurrentLead } from 'tokenGeneration/lead.util';

const AccountSelector = ({ onChange, disabled, value }: any) => {
  const partyIdParams = findParamFromUrl('partyId') ? findParamFromUrl('partyId') : getFromSessionStorage(MODULE_ID, SELECTED_PARTY_ACCOUNT);
  const userProfile = getFromSessionStorage(MODULE_ID, PROFILE_DATA);
  const { partyId, partyDetails, fetchPartyAccounts, setPartyAccount, fetchSelectedParty } = usePartyAccounts();
  const [openAccountSelector, setOpenAccountSelector] = useState(false);
  const [partyData, setPartyData] = useState({
    partyName: '',
    partyId: ''
  });
  const { lobDetails } = useProducts();
  const currentLobDetails = lobDetails || { key: LOB.DATA };

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    setPartyData(value);
  }, [value?.partyId]);

  const saveAndEmitPartyDetails = (partyDetails: any) => {
    if (partyDetails && partyDetails.partyId) {
      setPartyData(partyDetails);
      onChange(partyDetails);
      setInSessionStorage(MODULE_ID, SELECTED_PARTY_ACCOUNT, partyDetails.partyId);
      setInSessionStorage(MODULE_ID, SELECTED_PARTY_DATA, partyDetails);
      const params = window.location.search
        .split('&')
        .map((item) => {
          if (item.includes('partyId')) {
            item = `partyId=${partyDetails.partyId}`;
          }
          return item;
        })
        .join('&');

      history.replace({
        pathname: location.pathname,
        search: new URLSearchParams(params).toString()
      });
    } else {
      !partyIdParams && !getCurrentLead() && setOpenAccountSelector(true);
    }
  };

  const onSelectAccount = (partyAccount: any) => {
    setOpenAccountSelector(false);
    saveAndEmitPartyDetails(partyAccount);
  };

  const openAccountSelectorDialog = () => {
    disabled ? null : setOpenAccountSelector(true);
  };

  const onCloseBtnClick = () => {
    setOpenAccountSelector(false);
  };

  useEffect(() => {
    saveAndEmitPartyDetails(partyDetails);
  }, [partyDetails]);

  useLayoutEffect(() => {
    if (openAccountSelector) {
      setTimeout(() => {
        document.querySelector('.b2b-lib-party_selector_account .b2b-lib-cross_icon')?.addEventListener('click', onCloseBtnClick);
      }, 1000);
    }
    return () => {
      removeEventListener('click', onCloseBtnClick);
    };
  }, [openAccountSelector]);

  return (
    <div>
      <div onClick={openAccountSelectorDialog} className="input_box">
        <Input disabled={disabled} name="demo" type="text" value={partyData?.partyName} label="Account Selected" required />
        <i className="aeh-icon-outlined-chevron-down" />
      </div>
      <div style={{ display: openAccountSelector ? 'block' : 'none' }}>
        <PartySelector
          {...{
            fetchPartyAccounts,
            fetchSelectedParty,
            onSelectAccount,
            lobDetails: currentLobDetails,
            partyDetails,
            isOpenByDefault: openAccountSelector,
            aggregationLevel: PARTY_AGGREGATION_LEVEL.PARTY,
            user: userProfile?.profileType
          }}
        />
      </div>
    </div>
  );
};

export default AccountSelector;
